import React from 'react';
import { motion } from 'motion/react';
import {
  revealVariants,
  defaultViewport,
  premiumTransition,
} from '../motion/scrollMotion';
import './ScrollReveal.css';

const MOTION_TAGS = {
  div: motion.div,
  section: motion.section,
  article: motion.article,
  main: motion.main,
  footer: motion.footer,
  header: motion.header,
};

const ScrollReveal = ({
  children,
  className = '',
  variant = 'fadeUp',
  delay = 0,
  as = 'div',
  animateOnMount = false,
  duration = 0.95,
  ...rest
}) => {
  const Component = MOTION_TAGS[as] || motion.div;
  const variants = revealVariants[variant] || revealVariants.fadeUp;

  const motionProps = animateOnMount
    ? {
        initial: 'hidden',
        animate: 'visible',
        transition: premiumTransition(delay, duration),
      }
    : {
        initial: 'hidden',
        whileInView: 'visible',
        viewport: defaultViewport,
        transition: premiumTransition(delay, duration),
      };

  return (
    <Component
      className={`scroll-reveal scroll-reveal--${variant} ${className}`.trim()}
      variants={variants}
      {...motionProps}
      {...rest}
    >
      {children}
    </Component>
  );
};

export default ScrollReveal;
